import useAuth from '../../auth/authContext';
import { useFetchedTenantNotificationSettings } from './useFetchedTenantNotificationSettings';
import { useShouldShowPrompt } from '../../releaseprompt/hooks/useShouldShowPrompt';
import { isSupportUser } from '../../user/utils';

export const useShouldShowSmsNotificationsPrompt = () => {
  const {
    query: { data: tenantNotificationSettings },
  } = useFetchedTenantNotificationSettings();

  const {
    state: { user },
  } = useAuth();

  const { markReminded } = useShouldShowPrompt('SmsNotificationsSettings');

  const shouldShowModal =
    markReminded &&
    tenantNotificationSettings &&
    tenantNotificationSettings.smsEnabled === null &&
    user &&
    !isSupportUser(user.email);

  return { markReminded: shouldShowModal ? markReminded : null };
};
